/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { menuDeltaProductSchema } from "./menuDeltaProductSchema.ts";

export const updateActivityProductsSchema = menuDeltaProductSchema;
